import { Switch, Redirect } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import ContactPage from './ContactPage/ContactPage';
import DownloadTemplate from './DownloadTemplate/DownloadTemplate';
import UploadFilesContainer from './FileUpload/FileUploadContainer';
import ContactsPage from './ContactsPage/ContactsPage';
import CreateContactPage from './CreateContact/CreateContactPage';
import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const featureFlags = useModuleFeatureFlag('contacts');

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.AddBeneficiaries}
        showPermission
        exact
        path="/contacts/create"
        component={CreateContactPage}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewBeneficiaries}
        showPermission
        exact
        path="/contacts/:contactID"
        component={ContactPage}
      />

      {/* Orphan copy with the new flow's embedded Receivables/Payables tabs — URL only, no menu entry (ID-13335) */}
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewBeneficiaries}
        showPermission
        exact
        path="/accounting/contacts/:contactID"
      >
        <ContactPage accountingEnabled />
      </ProtectedRoute>

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewBeneficiaries}
        showPermission
        exact
        path="/contacts"
        component={ContactsPage}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.ViewBeneficiaries}
        showPermission
        exact
        path="/contact-list"
        render={() => {
          return <Redirect to="/contacts" />;
        }}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.AddBeneficiaries}
        showPermission
        exact
        path="/contact-file-upload"
        component={UploadFilesContainer}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.AddBeneficiaries}
        showPermission
        exact
        path="/contact-download-template"
        component={DownloadTemplate}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.AddBeneficiaries}
        showPermission
        exact
        path="/contact-create"
        render={() => {
          return <Redirect to="/contacts/create" />;
        }}
      />
    </Switch>
  );
};

export default Routes;
